import { Grid2, CircularProgress, Alert, TextField, Button, Box } from '@mui/material';
import { useState } from 'react';
import SideNav from '../Komponenten/Sidenav';
import Header from '../Komponenten/Header';
import { Hashtag } from '../Komponenten/Hashtag';
import { useTrainings } from '../api/trainingsApi';
import './Trainingszeiten.css';

export default function Trainingszeiten() {
    const { data: trainings, isLoading, error } = useTrainings();
    const sortedTrainings = trainings ? [...trainings].sort((a, b) => (a.pos ?? 0) - (b.pos ?? 0)) : [];
    const [formData, setFormData] = useState({
        name: '',
        kontakt: '',
        vorname: '',
        jahrgang: '',
        verein: '',
        nachricht: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Hier könnte man das Formular absenden, z.B. per Email oder API
        alert('Vielen Dank für Ihre Anfrage! Wir melden uns bald bei Ihnen.');
        setFormData({ name: '', vorname: '', jahrgang: '', verein: '', nachricht: '' });
    };

    return (
        <>
            <SideNav />
            <Grid2 container padding={5} spacing={4}>
                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <Header />
                </Grid2>

                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <h2 className="trainingszeiten-title"><Hashtag text="#DJK.Trainings.Zeiten" /></h2>
                </Grid2>

                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <div className="trainingszeiten-description">
                        In der aktuellen Saison 2025/26 trainieren unsere Fußball-Teams zu folgenden Zeiten:
                    </div>
                </Grid2>

                {isLoading && (
                    <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                        <CircularProgress style={{ color: 'var(--accent)' }} />
                    </Grid2>
                )}

                {error && (
                    <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                        <Alert severity="error" style={{ maxWidth: '800px' }}>
                            Wir haben momentan leider Probleme beim Laden der Trainginszeiten. Bitte versuchen Sie es später erneut.
                        </Alert>
                    </Grid2>
                )}

                {trainings && trainings.length > 0 && (
                    <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                        <div className="trainingszeiten-container">
                            <div className="trainingszeiten-grid">
                                {sortedTrainings.map((training) => (
                                    <div key={training.id} className="training-card">
                                        <div className="training-card-header">
                                            <h3 className="training-team">{training.team}</h3>
                                        </div>
                                        <div className="training-card-body">
                                            <div className="training-times">
                                                {training.trainings && training.trainings.length > 0 ? (
                                                    training.trainings.map((time, idx) => (
                                                        <div key={idx} className="training-time-item">
                                                            <span className="training-time">{time}</span>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <span className="training-time-empty">Keine Trainingszeiten erfasst</span>
                                                )}
                                            </div>
                                            {training.contact && (
                                                <div className="training-contact">
                                                    <strong>Kontakt:</strong>
                                                    <span>{training.contact}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Grid2>
                )}

                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <div className="trainingszeiten-description">
                        <strong><Hashtag text="#Probe.Trainings" /></strong>
                        <br/><br/>
                        Du willst eines unserer Teams kennenlernen? Gerne kannst Du ein Probe.Training vereinbaren. Mit einer kurzen Mail an unsere Jugendleitung unter <a href="mailto:jugend@djkdurlach.de">jugend@djkdurlach.de</a> kannst Du Dich zu einem Probetraining anmelden.
                        <br/><br/>
                        Damit Du auch ohne Vereins-Mitgliedschaft beim Probetraining versichert bist, benötigen wir von Dir ein paar Angaben zu Deiner Person: Name, Vorname, Jahrgang sowie deinen aktuellen Verein.
                        <br/><br/>
                        Gerne stimmen wir dann einen passenden Termin für ein Probetraining mit Dir ab.
                        <br/><br/>
                        <strong>Kontaktformular Probetraining</strong>
                    </div>
                </Grid2>

                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 600, width: '100%', background: 'rgba(0,0,0,0.4)', padding: 3, borderRadius: 2, border: '2px solid var(--accent)' }}>
                        <TextField
                            fullWidth
                            label="Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            margin="normal"
                            required
                            sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                        />
                        <TextField
                            fullWidth
                            label="Vorname"
                            name="vorname"
                            value={formData.vorname}
                            onChange={handleChange}
                            margin="normal"
                            required
                            sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                        />
                        <TextField
                            fullWidth
                            label="Jahrgang"
                            name="jahrgang"
                            value={formData.jahrgang}
                            onChange={handleChange}
                            margin="normal"
                            required
                            sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                        />
                        <TextField
                            fullWidth
                            label="Aktueller Verein"
                            name="verein"
                            value={formData.verein}
                            onChange={handleChange}
                            margin="normal"
                            sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                        />
                        <TextField
                            fullWidth
                            label="Kontakt (Email oder Telefon)"
                            name="kontakt"
                            value={formData.kontakt}
                            onChange={handleChange}
                            margin="normal"
                            sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                        />
                        <TextField
                            fullWidth
                            label="Nachricht (optional)"
                            name="nachricht"
                            value={formData.nachricht}
                            onChange={handleChange}
                            margin="normal"
                            multiline
                            rows={4}
                            sx={{ textarea: { color: 'white' }, label: { color: 'white' } }}
                        />
                        <Button type="submit" variant="contained" sx={{ mt: 2, backgroundColor: 'var(--accent)', color: 'black' }}>
                            Anfrage senden
                        </Button>
                    </Box>
                </Grid2>
            </Grid2>
        </>
    );
}